import { createActions, } from 'redux-actions';

export default createActions({
  STATISTICS: {
    SET: null,
  },
});
